// ReplyForm.jsx
import * as React from "react";
import {
    Box,
    Button,
    Checkbox,
    Container,
    FormControlLabel,
    Grid,
    Paper,
    TextField,
    Typography,
} from "@mui/material";
import withLanguage from "../../HOC/withLanguage";

function Contact() {
    const [values, setValues] = React.useState({
        comment: "",
        name: "",
        email: "",
        site: "",
        remember: false,
    });

    const onChange = (e) => {
        const { name, value, type, checked } = e.target;
        setValues((s) => ({ ...s, [name]: type === "checkbox" ? checked : value }));
    };

    const onSubmit = (e) => {
        e.preventDefault();
        // TODO: send values somewhere
        console.log(values);
    };

    return (
        <Paper elevation={0} sx={{ p: { xs: 2, sm: 3 } }}>
            <Typography variant="h6" sx={{ mb: 0.5, fontWeight: 600 }}>
                Lini një Përgjigje
            </Typography>

            <Typography variant="body2" sx={{ mb: 2, color: "text.secondary" }}>
                Adresa juaj email s’do të bëhet publike. Fushat e domosdoshme janë
                shënuar me një *
            </Typography>

            <Box component="form" onSubmit={onSubmit}>
                <TextField
                    label="Koment"
                    name="comment"
                    value={values.comment}
                    onChange={onChange}
                    multiline
                    rows={6}
                    fullWidth
                    required
                    sx={{ mb: 2 }}
                />

                <Grid container spacing={2} sx={{ mb: 1 }}>
                    <Grid item xs={12} md={4}>
                        <TextField
                            label="Emër"
                            name="name"
                            value={values.name}
                            onChange={onChange}
                            fullWidth
                            required
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            type="email"
                            label="Email"
                            name="email"
                            value={values.email}
                            onChange={onChange}
                            fullWidth
                            required
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            label="Sajt"
                            name="site"
                            value={values.site}
                            onChange={onChange}
                            fullWidth
                        />
                    </Grid>
                </Grid>

                <FormControlLabel
                    control={
                        <Checkbox
                            name="remember"
                            checked={values.remember}
                            onChange={onChange}
                        />
                    }
                    sx={{ mt: 0.5 }}
                    label="Ruaje në këtë shfletues emrin, email-in dhe sajtin tim, për herën tjetër që komentoj."
                />

                <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                    <Button
                        type="submit"
                        variant="contained"
                        size="large"
                        sx={{
                            px: 3,
                            borderRadius: 1.5,
                            textTransform: "none",
                            bgcolor: "#e85b2c",
                            "&:hover": { bgcolor: "#cf4f26" },
                        }}
                    >
                        Dergo emailin
                    </Button>
                </Box>
            </Box>
        </Paper>
    );
}

export default withLanguage(Contact, 'Homepage_Contact')
